import React, {useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/img/completionOfRegistration.png'

import './DetailsCompletion.scss';
import DetailsMain from '../../General/Details/DetailsMain';
import Header from '../../General/Static/Header';
import ladyArt from '../../../assets/img/wizard_bg.svg';
import LoginContext from '../../../store/login-context';
import GovSpinner from '../GovSpinner';
import Ajax from '../../../Handler/Ajax';
import Toast from '../Toast';
import mobileTitleImg from '../../../assets/img/completionOfRegistration.png';

declare function Translate(key: string): string;
declare var _curLang: any;

const DetailsCompletion = props => {  
  
  const ctx = useContext(LoginContext);
  const [isDetailsCompleted, setIsDetailsCompleted] = useState(false);
  const [loading,setLoading] = useState(false);
  const [serverMessage,setServerMessage] = useState(''); 
    
  const update = () => {
    props.forceUpdate();
  };
  
  const onDetailsCompleted = () => {    

    if(!ctx.devMode){      
      //check for use passkey. if not exists display market form 
      setLoading(true); 
      Ajax.continueRequest()
        .then((res:any) => {          
          Ajax.CheckEnrolledPasskeys()
          .then((res: any) => {
            setLoading(false);
            ctx.setSuccess();               
          })
          .catch((error) => {
            setLoading(false);
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
          }); 
        })
        .catch((error) => {
          setLoading(false);
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
        });          
    }
    else{
      ctx.setSuccess();         
    }
  };

  return (
    <React.Fragment>

    <GovSpinner show={loading} />
      
    <Container fluid className='px-0'>
      <Header
        showLogo={true}
        forceUpdate={update}
        isBiometricHeader={true}
      />
      <Row className='left-side'>
      <Col
          className='side-bg ps-0 pe-0'
          xl={5}
          lg={12}
          md={12}
          sm={12}
          xs={12}       
        >
          <div className='main-top-container'>
            <div
              className='side-upper'
              style={isDetailsCompleted ? { display: 'none' } : {}}
            >              
                <div>                    
                  {!isDetailsCompleted && (
                    <div>
                      <div className='side-title mb-2' role="heading" aria-level={2}>
                        {Translate('N_Login_Bio_ID_registration-title')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle_1')}
                      </div>
                    </div>
                  )}
                </div>                         
            </div>
            <div>
              <img src={mobileTitleImg} alt="" className='mobile-completion-title'/>             
            </div>
            <div className='dc_ladyArt_wrapper'>
              <img
                src={ladyArt}
                className='dc_ladyArt'
                alt=''
              />
            </div>              
          </div>
        </Col>

        <Col
          xl={7}
          lg={12}
          md={12}
          sm={12}
          xs={12}    
          className='left-container'
        > 
          {serverMessage.length > 0 && (
                <Toast message={serverMessage} />
          )}

          <DetailsMain            
            neededInfo={props.neededInfo}
            currentState={props.currentState}
            detailsCompleted={onDetailsCompleted}
          />         
        </Col>
      </Row>
     
    </Container>
    </React.Fragment>
  );


};
export default DetailsCompletion;

